import { FC } from 'react';
import { AutoFillGenericModal, AutoFillGenericModalTexts, OnSaveAutoFill } from 'components/auto-fill-generic';
import { PRESIGNED_UPLOAD_USE_CASE } from 'constants/common';

const JOB_MODAL_TEXTS: AutoFillGenericModalTexts = {
  title: 'AI job autofill',
  description: 'Upload a document or add notes to fill your job details',
  instructionsPlaceholder:
    // eslint-disable-next-line quotes
    "Tell us anything important… e.g., 'use the PDF for prices', 'tax included'. You can also paste an image",
  loadingTitle: 'Filling your job details',
  successMessage: 'Job details auto-filled successfully!'
};

interface AutoFillJobDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: OnSaveAutoFill;
  isSaving: boolean;
  onError?: (error: Error) => void;
}

const AutoFillJobDetailsModal: FC<AutoFillJobDetailsModalProps> = ({ isOpen, onClose, onSave, isSaving, onError }) => {
  return (
    <AutoFillGenericModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      texts={JOB_MODAL_TEXTS}
      enableFileUpload={true}
      uploadUseCase={PRESIGNED_UPLOAD_USE_CASE.JOB_AUTO_FILL}
      maxTextLength={1000}
      showTextAreaCharCount={true}
      onError={onError}
    />
  );
};

export default AutoFillJobDetailsModal;
